import { useMemo, useState } from 'react';
import { usePhrRouteMatch } from 'my-phr/layout/hooks';
import { useAuth } from 'Auth';
import { TAB_TYPES } from '../const';

export const SEARCH_CONTEXTS = {
  timeline: {
    id: 'timeline',
    labelKey: 'global-search.your-timeline',
    type: TAB_TYPES.primary,
  },
  dashboard: {
    id: 'dashboard',
    labelKey: 'global-search.your-dashboard',
    type: TAB_TYPES.primary,
  },
  library: {
    id: 'library',
    labelKey: 'global-search.your-library',
    type: TAB_TYPES.primary,
  },
};

function getMainTabs(authenticated, isTimeline, isDashboard) {
  if (!authenticated) return [SEARCH_CONTEXTS.library];

  if (isTimeline)
    return [
      SEARCH_CONTEXTS.timeline,
      SEARCH_CONTEXTS.dashboard,
      SEARCH_CONTEXTS.library,
    ];
  if (isDashboard)
    return [
      SEARCH_CONTEXTS.dashboard,
      SEARCH_CONTEXTS.timeline,
      SEARCH_CONTEXTS.library,
    ];

  return [
    SEARCH_CONTEXTS.library,
    SEARCH_CONTEXTS.dashboard,
    SEARCH_CONTEXTS.timeline,
  ];
}

export function useSearchTargets(current) {
  const { authenticated } = useAuth();
  const { isTimeline, isDashboard } = usePhrRouteMatch();

  const mainTabs = useMemo(
    () => getMainTabs(authenticated, isTimeline, isDashboard),
    [authenticated, isTimeline, isDashboard]
  );

  const [currentTabs, setCurrentTabs] = useState(mainTabs);

  const appendTabs = (secondaryTabs = []) => {
    setCurrentTabs([
      ...mainTabs,
      ...secondaryTabs.map((tab) => ({
        ...tab,
        type: TAB_TYPES.secondary,
      })),
    ]);
  };

  const currentIndex = currentTabs.findIndex(({ id }) => id === current);
  const nextId = currentTabs[(currentIndex + 1) % currentTabs.length]?.id;
  const previousId =
    currentTabs[(currentIndex - 1 + currentTabs.length) % currentTabs.length]
      ?.id;

  return {
    tabs: currentTabs,
    next: nextId,
    previous: previousId,
    isTimeline,
    isDashboard,
    appendTabs,
  };
}
